import HttpClient from '@/common/boot/HttpClient'


const listarEquipes = async ({ commit }, payload) => {

  commit('BUSCANDO', true);

  HttpClient.post('/ctrl-equipes/visualizar', payload).then(response => {
    commit('LISTAR_EQUIPES', response.data.data.data)
    commit('ATUALIZAR_PAGINACAO', response.data.data)

    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    })

  return true
}

const salvarEquipe = async ({ commit, dispatch }, payload) => {

  commit('BUSCANDO', true);

  return await HttpClient.post('/ctrl-equipes', payload).then(response => {
    dispatch('listarEquipes');
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

const atualizarEquipe = async ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true);
  return await HttpClient.put(`/ctrl-equipes/${payload.id}`, payload).then(response => {
    dispatch('listarEquipes');
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

const excluirEquipes = async ({ dispatch }, payload) => {
  let qtdRows = payload.length;
  for (let i = 0; i < qtdRows; ++i) {
    await excluirEquipe(payload[i]);
  }

  dispatch('listarEquipes');
}

const excluirEquipe = async (linha) => {
  const resp = await HttpClient.delete(`/ctrl-equipes/${linha.id}`).then(response => { return response; });
  return resp;
}

const listarUsuarios = async ({ commit }) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/usuarios`).then(response => {
    commit('INSERIR_LISTA_USUARIOS', response.data)
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    })
}

const recuperarEquipeComUsuarios = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/ctrl-equipes/${payload}/usuarios`, payload).then(response => {
    commit('INSERIR_EQUIPE_SELECIONADA', response.data.data)
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

const listarTarefas = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.post('/ctrl-tarefas/visualizar', payload || {}).then(response => {
    commit('INSERIR_LISTA_TAREFAS', response.data.data.data || [])
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

const listarTodasTarefas = async ({ commit }) => {
  commit('BUSCANDO', true);

  return await HttpClient.post('/ctrl-tarefas/visualizar', { per_page: 10000 }).then(response => {
    commit('INSERIR_LISTA_TODAS_TAREFAS', response.data.data.data || [])
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    })
}

const recuperarEquipeComTarefas = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/ctrl-equipes/${payload}/tarefas`, payload).then(response => {
    commit('INSERIR_EQUIPE_SELECIONADA', response.data.data)
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}


const associarUsuariosAEquipe = ({ commit }, payload) => {
  commit('BUSCANDO', true);

  HttpClient.post(`/ctrl-equipes/${payload.equipeId}/sincronizar-usuarios`, payload).then(response => {
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

const associarTarefasAEquipe = ({ commit }, payload) => {
  commit('BUSCANDO', true);

  HttpClient.post(`/ctrl-equipes/${payload.equipeId}/sincronizar-tarefas`, payload).then(response => {
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

const restaurarEquipe = async ({ dispatch, commit }, payload) => {
  commit('BUSCANDO', true);
  return await HttpClient.post(`/ctrl-equipes/${payload}/restaurar`).then(response => {
    dispatch('listarEquipes')
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

export {
  listarEquipes,
  salvarEquipe,
  atualizarEquipe,
  excluirEquipes,
  listarUsuarios,
  recuperarEquipeComUsuarios,
  listarTarefas,
  listarTodasTarefas,
  recuperarEquipeComTarefas,
  associarUsuariosAEquipe,
  associarTarefasAEquipe,
  restaurarEquipe
}